/**
 * @description Job Detail Title Placeholder.
 */
export const TitlePlaceholder = () => (
  <div className="mb-3 animate-pulse pt-1">
    <div className="h-10 w-full rounded bg-slate-400 md:w-2/3" />
  </div>
);
